// @ts-nocheck
import { useState, useEffect } from 'react';
import { getSupabaseClient } from '@em-cms/db';

interface PlatformSettings {
  platform_name: string;
  platform_tagline: string;
  platform_logo_url: string;
  platform_favicon_url: string;
  platform_primary_color: string;
  support_email: string;
  platform_url: string;
}

const DEFAULT_SETTINGS: PlatformSettings = {
  platform_name: 'AFCMS',
  platform_tagline: 'سیستم مدیریت محتوای حرفه‌ای',
  platform_logo_url: '',
  platform_favicon_url: '',
  platform_primary_color: '#6366f1',
  support_email: '',
  platform_url: 'https://app.afcms.tech',
};

export function usePlatformSettings() {
  const [settings, setSettings] = useState<PlatformSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      const supabase = getSupabaseClient();
      const { data } = await supabase.from('cms_system_settings').select('key, value');

      if (data) {
        const parsed: Record<string, any> = {};
        data.forEach((row: any) => {
          try { parsed[row.key] = JSON.parse(row.value); }
          catch { parsed[row.key] = row.value; }
        });

        setSettings({
          platform_name: parsed.platform_name || DEFAULT_SETTINGS.platform_name,
          platform_tagline: parsed.platform_tagline || DEFAULT_SETTINGS.platform_tagline,
          platform_logo_url: parsed.platform_logo_url || DEFAULT_SETTINGS.platform_logo_url,
          platform_favicon_url: parsed.platform_favicon_url || DEFAULT_SETTINGS.platform_favicon_url,
          platform_primary_color: parsed.platform_primary_color || DEFAULT_SETTINGS.platform_primary_color,
          support_email: parsed.support_email || DEFAULT_SETTINGS.support_email,
          platform_url: parsed.platform_url || DEFAULT_SETTINGS.platform_url,
        });
      }
      setLoading(false);
    };

    loadSettings();
  }, []);

  return { ...settings, loading };
}
